import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AxiosResponse } from "axios";
import { RootState } from "src/app/store";
import { apiCaller } from "../../util/apiCaller";

interface DataState {
  loading: boolean;
  error: any;
  data: Record<string, unknown>; // Sử dụng unknown type cho data
}

const initialState: DataState = {
  loading: false,
  error: null,
  data: {},
};

interface YourDataType {
  loading: boolean;
  error: any;
  data: Record<string, unknown>;
  getName: any;
}

interface YourParamsType {
  url: string;
  method: string;
  apiType?: string;
  getName?: any;
}

export const fetchApi = createAsyncThunk(
  "commomApi",
  async (params: YourParamsType): Promise<AxiosResponse<YourDataType>> => {
    const response = await apiCaller(params);
    return response?.data.content;
  }
);

const fetchDataSlice = createSlice({
  name: "commomApi",
  initialState,
  reducers: {
    clearDataApi: (state, action: PayloadAction<string>) => {
      const getName = action.payload;
      delete state.data[getName];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchApi.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchApi.fulfilled, (state, action) => {
        const getName = action.meta.arg?.getName;
        state.data[getName] = action.payload;
        state.loading = false;
      })
      .addCase(fetchApi.rejected, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearDataApi } = fetchDataSlice.actions;

export const selectData = (state: RootState) => state.commonApi.data;

export default fetchDataSlice.reducer;
